import React, { createContext, useContext, useState, useCallback } from "react";

type EnrollmentFormContextType = {
    editing: boolean;
    editingKey: string;
    setEditingKey: (editingKey?: string) => void;
    // isCompleted?: boolean;
    // setIsCompleted?: (completed: boolean) => void;
};

export const EnrollmentFormContext = createContext<EnrollmentFormContextType>({
    editing: false,
    editingKey: '',
    setEditingKey: (editingKey?: string) => { },
    // isCompleted: false,
    // setIsCompleted: (completed: boolean) => { }
});

export const useEnrollmentFormContext = () => useContext(EnrollmentFormContext);

interface EnrollmentFormProviderProps {
    children: React.ReactNode;
}

export const EnrollmentFormProvider: React.FC<EnrollmentFormProviderProps> = ({ children }) => {
    const [editingKey, setEditingKey] = useState('');
    const [isCompleted, setIsCompleted] = useState(false);

    const _setEditing = useCallback((key?: string) => {
        setEditingKey(key ?? '');
    }, []);

    const _setIsCompleted = useCallback((completed: boolean) => {
        setIsCompleted(completed);
    }, []);


    return (
        <EnrollmentFormContext.Provider value={{
            editing: editingKey !== '',
            editingKey, setEditingKey: _setEditing,
            // isCompleted,
            // setIsCompleted: _setIsCompleted
        }}>
            {children}
        </EnrollmentFormContext.Provider>
    );
};
